import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { useAuth } from '../../context/AuthContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlus, FiEdit3, FiUsers, FiSettings, FiLogOut, FiHome, FiClock, FiCoffee } = FiIcons;

const AdminDashboard = () => {
  const [stats, setStats] = useState({ totalEntries: 0, totalPeople: 0 });
  const { signOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { fetchStats(); }, []);

  const fetchStats = async () => {
    const [entries, people] = await Promise.all([
      supabase.from('entries_20240520').select('*', { count: 'exact' }),
      supabase.from('people_20240520').select('*', { count: 'exact' }),
    ]);
    setStats({ totalEntries: entries.count || 0, totalPeople: people.count || 0 });
  };

  const menu = [
    { title: 'New Memory', path: '/admin/entries/new', icon: FiPlus, color: 'bg-emerald-500' },
    { title: 'Manage Memories', path: '/admin/entries', icon: FiEdit3, color: 'bg-blue-500' },
    { title: 'Family Members', path: '/admin/people', icon: FiUsers, color: 'bg-amber-500' },
    { title: 'Traditions', path: '/admin/traditions', icon: FiClock, color: 'bg-purple-500' },
    { title: 'Recipes', path: '/admin/recipes', icon: FiCoffee, color: 'bg-orange-500' },
    { title: 'Security Settings', path: '/admin/settings', icon: FiSettings, color: 'bg-slate-700' },
  ];

  return (
    <div className="max-w-5xl mx-auto px-4 py-12">
      <div className="flex justify-between items-end mb-10">
        <div>
          <h1 className="text-4xl font-serif font-bold text-[#2c2c2c] mb-2">Parents Dashboard</h1>
          <p className="text-[#6b6b6b]">Welcome back! Manage the family archive below.</p>
        </div>
        <div className="flex gap-3">
          <Link to="/" className="p-3 bg-white border border-stone-200 rounded-xl hover:bg-stone-50"><SafeIcon icon={FiHome} /></Link>
          <button onClick={() => { signOut(); navigate('/admin/login'); }} className="p-3 bg-red-50 border border-red-100 rounded-xl text-red-600 hover:bg-red-100"><SafeIcon icon={FiLogOut} /></button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {menu.map(item => (
          <Link key={item.path} to={item.path} className="p-8 bg-white rounded-[2.5rem] border border-stone-200 hover:shadow-xl hover:-translate-y-1 transition-all group">
            <div className={`w-14 h-14 ${item.color} text-white rounded-2xl flex items-center justify-center mb-6 shadow-lg`}>
              <SafeIcon icon={item.icon} className="w-7 h-7" />
            </div>
            <h3 className="font-bold text-xl text-[#2c2c2c]">{item.title}</h3>
            <p className="text-sm text-stone-400 mt-1">Manage {item.title.toLowerCase()} content.</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;